import {Component, EventEmitter, Inject, Input, Output} from '@angular/core';
import {IGetImageService, IGetImageServiceToken} from '../../../../../../@core/services/images/IGetImageService';

@Component({
  selector: 'app-secured-image-display',
  standalone: false,
  templateUrl: './secured-image-display.component.html',
  styleUrl: './secured-image-display.component.scss'
})
export class SecuredImageDisplayComponent<T> {
    private _data:T;
    isLoaded = false;


    @Input({required:true}) set data (data:T){
        this._data=data;
        this.isLoaded = false;
    }
    get data() : T {return this._data; }
    @Input() alt:string="";
    @Output() imageLoaded:EventEmitter<void> = new EventEmitter<void>();
    @Output() loadingError:EventEmitter<void> = new EventEmitter<void>();
    @Output() loading:EventEmitter<void> = new EventEmitter<void>();


    constructor(@Inject(IGetImageServiceToken) private imageService: IGetImageService) {
    }

    get imageUrl(){
        if(this.data){
            return this.imageService.getImageUrl(this.data) ?? null;
        }

        this.loading.emit();
    }


    onSuccess() {
        this.isLoaded = true;
        this.imageLoaded.emit();
    }

    onError() {
        this.isLoaded = false;
        this.loadingError.emit();
    }

    onLoadStarted() {
        this.loading.emit();
    }
}
